enum API {
	PERMISSIONS = '/api/settings/privilegies/permission',
	ACTION_PERMISSIONS = '/api/settings/privilegies/actPermission/'
}

export default API;
